import { createStructuredSelector } from 'reselect';

import { appealDataRequestLoadingSelector } from '../../store/appealDataRequest/selectors';
import {
  stepShowConfirmationSelector,
  stepConfirmationSelector,
} from '../../store/step/selectors';
import {
  currentExamSelector,
  appealGradesExamSelector,
} from '../../store/examData/selectors';

const structuredSelector = createStructuredSelector({
  loading: appealDataRequestLoadingSelector,
  exam: currentExamSelector,
  appealGrades: appealGradesExamSelector,
  showConfirmation: stepShowConfirmationSelector,
  stepConfirmation: stepConfirmationSelector,
});

export default structuredSelector;
